export default __webpack_public_path__ + "static/media/antp_coloquio_JavierVera.db004e5e.png";